import ImportRepository from "@domain/repositories/ImportRepository";
import UseCase from "@domain/UseCase";
import { ImportHistory } from "@domain/models/ImportHistory";
import { ImportJob } from "@domain/models/ImportJob";

type Input = ImportHistory["id"];

type Output = Promise<ImportJob>;

export class UndoImportClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly importRepository: ImportRepository) {}

  execute(importHistoryId: Input) {
    return this.importRepository.undoImportClients(importHistoryId);
  }
}
